import { useEffect, useState, useContext } from "react";
import { DataContext } from '../context/DataProvider';

export default function CalculadoraSodimac() {
    const [cm2, setCm2] = useState('');
    const [alto, setAlto] = useState('');
    const [largo, setLargo] = useState('');
    const [adicional, setAdicional] = useState(10);
    const [puertas, setPuertas] = useState(0);
    const [ventanas, setVentanas] = useState(0);
    const [areaCalculada, setAreaCalculada] = useState(null);
    const [materiales, setMateriales] = useState([]);
    const [currentStep, setCurrentStep] = useState(2);
    const [useAlternateCalculation, setUseAlternateCalculation] = useState(false);
    const [productsShow, setProductsShow] = useState([]);
    const [totalPrecio, setTotalPrecio] = useState(0);
    const { fetchProductDetails, dataProductos, dataTextos, addToCart, defaultProductsDetails, addedToCart, setAddedToCart, loadingCart, messageAddToCart, setMessageAddToCart, globalReset } = useContext(DataContext);

    // Medidas estándar en centímetros
    const puertaArea = 80 * 210; // Puerta 80x210 cm
    const ventanaArea = 90 * 120; // Ventana 90x120 cm

    
    useEffect(() => {
        if (productsShow.length > 0 && dataProductos) {
            const nuevosMateriales = productsShow.map((producto) => {
                const sku = producto?.product?.id || producto?.product?.sku || "";
                const datosProducto = Object.values(dataProductos).find(p => p.sku === sku);
                const cantidad_unica = datosProducto?.cantidad_unica ?? 1;

                return {
                    foto: producto.product.mediaUrls[0],
                    cantidad: Math.ceil(Number(cantidad_unica)) || 1,
                    ...producto.product,
                };
            });

            const total = nuevosMateriales.reduce((acc, material) => {
                const rawPrice = material.prices?.[0]?.originalPrice || "0";
                const precioUnitario = parseFloat(rawPrice.replace(/\./g, ''));
                return acc + (precioUnitario * material.cantidad);
            }, 0);

            const totalFormateado = total.toLocaleString('es-CL');
            setMateriales(nuevosMateriales);
            setTotalPrecio(totalFormateado);
            setCurrentStep(2); // <-- aquí debe ser 2, no 3
        }
    }, [productsShow, dataProductos]);

    useEffect(() => {
      if (dataProductos && productsShow.length === 0) {
        const cargarProductosFijos = async () => {
          try {
            const data = await fetchProductDetails(0);
            setProductsShow(data);
            setCurrentStep(2);
          } catch (err) {
            console.error("Error al cargar productos fijos:", err);
          }
        };

        cargarProductosFijos();
      }
    }, [dataProductos]);


    function calcularCantidad(productId) {
        const productoCantidad = defaultProductsDetails[productId];
        if (!productoCantidad) return 0;

        const superficieM2 = Number(largo) * (1 + (Number(adicional) / 100)); // largo en metros lineales
        const espesorCm = Number(alto) > 0 ? Number(alto) : 10; // usa el valor ingresado o 10 cm por defecto
        const rendimiento = Number(productoCantidad.rendimiento_m2); // m² a 10 cm de espesor

        if (!superficieM2 || !rendimiento) return 0;

        // Ajuste para rendimiento a 10 cm de espesor
        let cantidad = (superficieM2 * (espesorCm / 10)) / rendimiento;
        return cantidad > 0 && cantidad < 1 ? 1 : Math.ceil(cantidad);
    }

    // Para el input directo de cm2
    const calcularSuperficie = () => {
        const areaPuertas = puertas * puertaArea;
        const areaVentanas = ventanas * ventanaArea;
        const areaTotalRestada = cm2 - (areaPuertas + areaVentanas);
        const areaConAdicional = parseFloat(areaTotalRestada) + (parseFloat(areaTotalRestada) * (adicional / 100));
        setAreaCalculada(Number(areaConAdicional.toFixed(2)));
    };

    // Para el cálculo alternativo (alto y largo en cm)
    const calcularAreaAltoLargo = () => {
        let area = Number(alto) * Number(largo);
        const areaPuertas = puertas * puertaArea;
        const areaVentanas = ventanas * ventanaArea;
        const areaTotalRestada = area - (areaPuertas + areaVentanas);
        const areaConAdicional = areaTotalRestada + (areaTotalRestada * (adicional / 100));
        setAreaCalculada(Number(areaConAdicional.toFixed(2)));
    };

    const realizarLlamadaAPI = async () => {
        try {
            if (!areaCalculada) {
                useAlternateCalculation ? calcularAreaAltoLargo() : calcularSuperficie();
                return;
            }
            const data = await fetchProductDetails(areaCalculada);
            console.log("Productos cargados:", data); //nuevo codigo
            setProductsShow(data);
        } catch (error) {
            console.error("Error en la llamada API:", error);
        }
    };

    const incrementarPuertas = () => setPuertas(puertas + 1);
    const decrementarPuertas = () => setPuertas(puertas > 0 ? puertas - 1 : 0);
    const incrementarVentanas = () => setVentanas(ventanas + 1);
    const decrementarVentanas = () => setVentanas(ventanas > 0 ? ventanas - 1 : 0);

    const volverASeleccion = () => {
        setCurrentStep(1);
        setAreaCalculada(null);
        setPuertas(0);
        setVentanas(0);
        setProductsShow([]);
        setUseAlternateCalculation(false);
        setMessageAddToCart('');
        setAddedToCart(false);
    };


    const volverAPasoDos = () => {
        if (currentStep === 3) {
            setCurrentStep(2);
            // setPuertas(0);
            // setVentanas(0);
            setProductsShow([]);
            setAreaCalculada(null);
            setMessageAddToCart('');
            setAddedToCart(false);
        }
    };

    const volverASeleccionResert = () => {
        setCm2('');
        setCurrentStep(1);
        setAreaCalculada(null);
        setPuertas(0);
        setVentanas(0);
        setProductsShow([]);
        setUseAlternateCalculation(false);
        globalReset();
        setMessageAddToCart('');
        setAddedToCart(false);
    };

    const convertirURL = (url, id) => {
        const marca = obtenerMarcaPorSku(dataProductos, id);
        const newUrl = url.replace("https://sodimac.falabella.com", "https://www.sodimac.cl")
            .replace("/product/", "/articulo/");

        return newUrl + (marca);
    }

    const obtenerMarcaPorSku = (dataProductos, id) => {
        for (const key in dataProductos) {
            if (dataProductos[key].sku === id) {
                return dataProductos[key].marca;
            }
        }
        return null;
    };

    useEffect(() => {
        if (areaCalculada && currentStep === 2) {
            realizarLlamadaAPI();
        }
    }, [areaCalculada, currentStep]);

    const handleCalcularClick = async () => {
        // Calcula el volumen en m³
        let volumen = Number(largo) * (Number(alto) / 100);
        volumen = volumen + (volumen * (adicional / 100));
        setAreaCalculada(Number(volumen.toFixed(2)));

        // Llama a la API y muestra resultados
        const data = await fetchProductDetails(Number(volumen.toFixed(2)));
        setProductsShow(data);

        // Calcula materiales y precio total
        const nuevosMateriales = data.map((producto) => ({
            foto: producto.product.mediaUrls[0],
            cantidad: Math.ceil(calcularCantidad(producto.product.id)),
            ...producto.product,
        }));

        const total = nuevosMateriales.reduce((acc, material) => {
            const rawPrice = material.prices?.[0]?.originalPrice || "0";
            const precioUnitario = parseFloat(rawPrice.replace(/\./g, ''));
            return acc + (precioUnitario * material.cantidad);
        }, 0);

        const totalFormateado = total.toLocaleString('es-CL');
        setMateriales(nuevosMateriales);
        setTotalPrecio(totalFormateado);

        setCurrentStep(2);
    };

    return (
        <div className="non-steps">
            {dataProductos && dataTextos && (
                <div className="container text-center mb-4 px-0">
                    

                    {/* Paso 2: Mostrar materiales */}
                    {currentStep === 2 && (
                        <div className="container text-center mb-4 box-calculadora py-3">
                            {materiales.length === 0 ? (
                                <div className="my-5">
                                    <span>Cargando materiales...</span>
                                </div>
                            ) : (
                                <>
                                    <h2 className="mb-0" style={{ fontSize: "18px", paddingBottom: "1em", }}>
                                        {dataTextos.tituloResultado1} <strong>{dataTextos.tituloProyectoActual}</strong> {dataTextos.tituloResultado2}
                                    </h2>

                                    <form className="main-form rounded px-2 py-2">
                                        <div className="div-main-form bg-form-muro px-2 py-2">
                                            <div className="form-muro">
                                                <table className="table mt-0">
                                                    <thead>
                                                        <tr>
                                                            <th colSpan={"3"} className="text-start">
                                                                {dataTextos.tituloMaterial}
                                                            </th>
                                                            {/* <th>
                                                    {dataTextos.tituloCantidad}
                                                </th> */}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {productsShow && productsShow.length > 0 && materiales.map((material, index) => (
                                                            <tr key={index}>
                                                                <td className="px-1 py-2"><a href={convertirURL(material.url, material.variantId)}><img className="p-1" src={material.foto} alt={material.displayName} style={{ width: "80px" }} /></a></td>
                                                                <td className="product-detail py-2 px-2" style={{ fontSize: "14px", verticalAlign: "middle" }}>
                                                                    <a href={convertirURL(material.url, material.variantId)} className="noLinkStyle">
                                                                        <span className="brand-name">{material.brand}</span><br />
                                                                        <span className="product-name">
                                                                            {
                                                                                material.displayName.length > 47
                                                                                    ? material.displayName.slice(0, 47) + "..."
                                                                                    : material.displayName
                                                                            }
                                                                        </span><br />
                                                                        <span className="price">${material.prices[0].originalPrice}
                                                                            {material.prices[0].opportunidadUnica === true && (
                                                                                <img
                                                                                    className="oportunidad-unica p-1 ms-1"
                                                                                    src="https://www.sodimac.cl/a/fa/product/static/styles/svg/cmrIcon.svg"
                                                                                    alt="Oportunidad Única"
                                                                                    style={{ width: "50px" }}
                                                                                />
                                                                            )}</span>
                                                                    </a>
                                                                </td>
                                                                <td className="px-1 py-2" style={{ fontSize: "18px", verticalAlign: "middle" }}>
                                                                    {material.cantidad}<br />
                                                                    <span className="brand-name">
                                                                        {material.cantidad === 1 || material.cantidad === 0 ? "Unidad" : "Unidades"}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div className="container text-center mb-3 py-0">
                                            <span className="total-price"><span className="total-price-title">{dataTextos.totalProyecto} </span>${totalPrecio}</span>
                                        </div>

                                        {messageAddToCart === "success" && (
                                            <div className="alert alert-success p-2">
                                                <small>
                                                    {dataTextos.textSuccess}
                                                </small>
                                            </div>
                                        )}
                                        {messageAddToCart === "failed" && (
                                            <div className="alert alert-danger p-2">
                                                <small>
                                                    {dataTextos.textFail}
                                                </small>
                                            </div>
                                        )}

                                        {!addedToCart && (
                                            <div className="mt-0">
                                                <button type="button" onClick={e => addToCart(materiales)} className={loadingCart ? "btn btn-calcular disabled" : "btn btn-calcular"}>
                                                    {loadingCart ? "Agregando..." : dataTextos.ctaCarrito}
                                                </button>
                                            </div>
                                        )}

                                        {addedToCart && (
                                            <div className="mt-0">
                                                <a href={dataTextos.urlCarrito} target="_top" className="btn btn-calcular">
                                                    {dataTextos.ctaVerCarrito}
                                                </a>
                                            </div>
                                        )}


                                        <div className="container text-center mb-1 py-0 mt-3">
                                            <p className="" style={{ fontSize: "10px", lineHeight: "1.4" }}>
                                                {dataTextos.textoDespuesDelCarro}
                                            </p>
                                        </div>
                                    </form>
                                </>
                            )}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}









